import Splide from '@splidejs/splide'

export function slider() {
	const sliders = []
	let elms = document.querySelectorAll('.splide:not(.splide--facts)')

	for (var i = 0; i < elms.length; i++) {
		sliders.push(new Splide(elms[i]).mount())
	}

	return sliders
}
